import { render, staticRenderFns } from "./ClinicEdit.vue?vue&type=template&id=eb637f2e"
import script from "./ClinicEdit.vue?vue&type=script&lang=js"
export * from "./ClinicEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports